var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teaching-catalo-discussion"},[_c('div',{staticClass:"teaching-catalo-discussion-head"},[_c('span',{staticStyle:{"font-weight":"bold"},domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }